/** Per-browser convenience: the project Projects reopens. Storage may be unavailable. */
const KEY = 'viko.lastProject'

export function rememberProject(id: string) {
  try {
    localStorage.setItem(KEY, id)
  } catch {
    // ignore
  }
}

/** The remembered project if it still exists, otherwise the first listed one. */
export function defaultProject(ids: readonly string[]): string | undefined {
  let last: string | null = null
  try {
    last = localStorage.getItem(KEY)
  } catch {
    // ignore
  }
  return last && ids.includes(last) ? last : ids[0]
}
